import { DownloadIcon } from "@components/icon";
import { TFormTable } from "@components/smart/smartFormGroup/SmartFormGroup";
import BindingContext from "@odata/BindingContext";
import { EntitySetName, IPrEmployeeEntity, PrEmployeeEntity } from "@odata/GeneratedEntityTypes";
import { userNameWithAvatarTableFormatter } from "@pages/admin/users/Users.utils";
import { ClickableStyled } from "@pages/payroll/payrollYearOperations/screens/PayrollYearOperationScreen.styles";
import FileStorage from "@utils/FileStorage";
import { saveAs } from "file-saver";
import i18next from "i18next";
import React from "react";

import { REST_API_URL } from "../../../../constants";
import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import { addCompanyIdToUrl } from "../../../../contexts/appContext/AppContext.utils";
import { BasicInputSizes, IconSize, Sort } from "../../../../enums";

const PAYROLL_SHEET_PATH = BindingContext.localContext("PayrollSheet");

const PAYROLL_SHEET_PDF_EXPORT_URL = `${REST_API_URL}/PrPayrollSheetPdfExport`;

export const downloadPayrollSheet = async (employeeIds: number[], year: string, context: IAppContext): Promise<void> => {
    if (!employeeIds || employeeIds.length === 0) {
        return;
    }

    try {
        const url = addCompanyIdToUrl(`${PAYROLL_SHEET_PDF_EXPORT_URL}?${employeeIds.map(id => `employeeIds=${id}`).join("&")}&startYear=${year}&endYear=${year}&startMonth=${1}&endMonth=${12}`, context);
        const file = await FileStorage.get(null, { url });

        saveAs(file);
    } catch (error) {
        console.error(`Error downloading payroll sheet for employee ${employeeIds.toString()} and year ${year}`, error);
    }
};

export const getPayrollSheetsProcessingTableDef = (context: IAppContext, year: string): TFormTable => {
    return {
        id: `PayrollSheetsProcessingTable`,
        entitySet: EntitySetName.PrEmployees,
        initialSortBy: [
            { id: PrEmployeeEntity.NumberOurs, sort: Sort.Asc }
        ],
        columns: [{
            id: PrEmployeeEntity.NumberOurs,
            label: i18next.t("Employee:Table.Number")
        }, {
            id: PrEmployeeEntity.FirstName,
            label: i18next.t("Employee:Table.EmployeeName"),
            width: BasicInputSizes.L,
            formatter: userNameWithAvatarTableFormatter,
            additionalProperties: [{ id: `/${PrEmployeeEntity.LastName}` }]
        }, {
            id: PAYROLL_SHEET_PATH,
            label: i18next.t("PayrollYearOperation:PayrollSheetsProcessing.PayrollSheet"),
            disableSort: true,
            formatter: (val, args) => {
                const employee = args.entity as IPrEmployeeEntity;
                const sheetName = `${i18next.t("PayrollYearOperation:PayrollSheetsProcessing.PayrollSheet")} - ${employee.FirstName} ${employee.LastName}`;
                return {
                    tooltip: sheetName,
                    value: (
                        <ClickableStyled
                            $withoutMargin
                            onClick={downloadPayrollSheet.bind(null, [employee.Id], year, context)}>
                            {sheetName}
                            <DownloadIcon width={IconSize.S} height={IconSize.S}/>
                        </ClickableStyled>
                    )
                };
            },
            additionalProperties: [{ id: PrEmployeeEntity.LastName }, { id: PrEmployeeEntity.FirstName }]
        }]
    };
};